import { useContext, useCallback } from "react";
import { CommonComponentContext } from "../utils/CommonComponentContext";
import useNetwork from "./networkHook";

export function useUpsertSetting() {
    const commonContext = useContext(CommonComponentContext);
    const network = useNetwork();
    return useCallback((...props) => commonContext.upsertSetting(network, ...props), [network, commonContext.upsertSetting]);
}

export function useSetting(key) {
    const commonContext = useContext(CommonComponentContext);
    return commonContext.useSetting(key);
}

export function useSettingsLoading() {
    const commonContext = useContext(CommonComponentContext);
    return commonContext.useSettingsLoading();
}